import { render } from "./WorkerDetailForm.vue?vue&type=template&id=47517bd6"
import script from "./WorkerDetailForm.vue?vue&type=script&lang=js"
export * from "./WorkerDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__